import { debounceTime } from 'rxjs/operators';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { ApiService } from './api.service';

export class MissingStringsHandler implements MissingTranslationHandler {
  private missingKeys: { [key: string]: string } = {};
  private allMissingKeys: { [key: string]: string } = {};
  private debounceSubject = new Subject();
  private currentLanguage: string;

  constructor(private apiService: ApiService) {
    this.debounceSubject.pipe(debounceTime(1000)).subscribe(() => this.addDefaultValuesToMissingKeys());
  }

  handle(params: MissingTranslationHandlerParams) {
    const globalKey = `${params.key}.${params.translateService.currentLang}`;
    if (!this.allMissingKeys[globalKey]) {
      this.allMissingKeys[globalKey] = 'added';
      this.missingKeys[params.key] = '';
      // params.translateService.set(params.key, '', params.translateService.currentLang);
      this.debounceSubject.next(null);
      this.currentLanguage = params.translateService.currentLang;
    }
    return params.key;
  }

  private addDefaultValuesToMissingKeys() {
    if (!this.currentLanguage) {
      return;
    }
    this.apiService.post(`/inspectionreport/i18n/${this.currentLanguage}`, this.missingKeys).subscribe(() => {
      this.missingKeys = {};
    });
  }
}
